import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'
import EditButton from '../Shared/components/EditButton'
import ProgramSummaryView from './ProgramSummaryView'
import wordings from '../Shared/wordings.json'
import { getEstimatedMonthlySpend } from '../Shared/helperFunctions'
import { StaticAssetsUrl } from 'redux/config/services/Constants'
import DrawerView from 'core-system/Drawer/Drawer'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/config/store'

const ChildrenContainer = styled.div`
  padding: 1.5rem;
  height: 100%;
`

const NameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
`

const NameText = styled(Text)`
  font-weight: 700;
`

const SummaryContainer = styled.div`
  padding-bottom: 3rem;
`

interface SummaryDrawerViewProps {
  isOpen: boolean
  onClose: () => void
  superProgram: any
  onEditClick: (superProgram: any) => void
}

const SummaryDrawerView = ({
  isOpen,
  onClose,
  superProgram = {},
  onEditClick,
}: SummaryDrawerViewProps) => {
  const { irsTaxLimit } = useSelector(
    (state: AppState) => state.application.properties
  )

  const {
    selectedPrograms,
    grh,
    qtf,
    micromobility,
    flex,
    transitPass,
    coupon,
    selectedSegments,
    selectedDate,
    cancelledSegments,
    currency,
  } = superProgram

  return (
    <DrawerView isOpen={isOpen} onClose={onClose}>
      <img
        src={`${StaticAssetsUrl}/programs/program_drawer_top.svg`}
        alt='top'
      />
      <ChildrenContainer>
        <NameContainer>
          <NameText variant='h4'>{superProgram.name}</NameText>
          <EditButton onClick={() => onEditClick(superProgram)} />
        </NameContainer>
        <SummaryContainer>
          <ProgramSummaryView
            title={wordings.summaryTitle}
            selectedPrograms={selectedPrograms}
            grh={grh}
            qtf={qtf}
            micromobility={micromobility}
            flex={flex}
            transitPass={transitPass}
            coupon={coupon}
            displayType='drawer'
            selectedSegments={selectedSegments}
            cancelledSegments={cancelledSegments}
            monthlySpendDescription={wordings.monthlySpendDescription}
            estimatedMonthlySpend={getEstimatedMonthlySpend(
              selectedPrograms,
              qtf,
              grh,
              micromobility,
              flex,
              transitPass
            )}
            selectedDate={selectedDate}
            irsTaxLimit={irsTaxLimit}
            currency={currency}
          />
        </SummaryContainer>
      </ChildrenContainer>
    </DrawerView>
  )
}

// Helps to identify component in React error logs
if (process.env.NODE_ENV !== 'production') {
  SummaryDrawerView.displayName = 'ProgramsSummaryDrawerView'
}

export default React.memo(SummaryDrawerView)
